import * as React from "react";

class DialogCText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogC-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 226.765 172.104"
      >
        <g>
          <path
            fill="#5D87C0"
            d="M27.6,44.4h7.8v1.7h-5.7v3.7h4.9v1.8h-4.9v4.3h5.9v1.8h-8C27.6,57.7,27.6,44.4,27.6,44.4z"
          />
          <path
            fill="#5D87C0"
            d="M36.9,55c0-2.1,1.8-3.2,5.9-3.7c0-1.2-0.4-2.2-1.9-2.2c-1,0-2,0.5-2.9,1l-0.8-1.4c1-0.6,2.4-1.3,4-1.3
			c2.5,0,3.6,1.6,3.6,4.2v6h-1.7L43,56.5l0,0c-0.9,0.8-2,1.4-3.2,1.4C38.1,57.9,36.9,56.8,36.9,55z M42.8,55.1v-2.4
			c-2.9,0.4-3.9,1.1-3.9,2.2c0,1,0.7,1.4,1.5,1.4C41.3,56.2,42,55.8,42.8,55.1z"
          />
          <path
            fill="#5D87C0"
            d="M46.1,56.5l1-1.3c0.9,0.7,1.7,1.1,2.8,1.1c1.2,0,1.7-0.6,1.7-1.3c0-0.9-1.1-1.3-2.2-1.7
			c-1.3-0.5-2.8-1.2-2.8-2.9s1.3-2.9,3.5-2.9c1.3,0,2.4,0.5,3.2,1.2l-1,1.3c-0.7-0.5-1.4-0.9-2.2-0.9c-1.1,0-1.6,0.5-1.6,1.2
			c0,0.8,1,1.2,2.1,1.6c1.4,0.5,2.9,1.1,2.9,3c0,1.7-1.3,3-3.8,3C48.4,57.9,47,57.3,46.1,56.5z"
          />
          <path
            fill="#5D87C0"
            d="M54.3,52.7c0-3.3,2.2-5.2,4.7-5.2c2.4,0,4.7,1.9,4.7,5.2s-2.2,5.2-4.7,5.2C56.6,57.9,54.3,56,54.3,52.7z
			 M61.5,52.7c0-2.1-1-3.5-2.5-3.5s-2.5,1.4-2.5,3.5s1,3.5,2.5,3.5C60.6,56.2,61.5,54.8,61.5,52.7z"
          />
          <path
            fill="#5D87C0"
            d="M65.4,47.7h1.7l0.2,1.4h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.1,0,3,1.4,3,3.9v6.2h-2.1v-6c0-1.7-0.5-2.4-1.7-2.4
			c-0.9,0-1.5,0.5-2.4,1.4v7h-2.1V47.7z"
          />
          <path
            fill="#5D87C0"
            d="M75.6,49.4c0-0.8,0.6-1.5,1.4-1.5s1.4,0.6,1.4,1.5c0,0.8-0.6,1.4-1.4,1.4S75.6,50.2,75.6,49.4z M75.6,56.4
			c0-0.8,0.6-1.5,1.4-1.5s1.4,0.6,1.4,1.5s-0.6,1.4-1.4,1.4S75.6,57.3,75.6,56.4z"
          />
          <path
            fill="#5D87C0"
            d="M31.2,79.6c-0.5,0.1-1,0.2-1.5,0.2V81h1.1v1.1h-1.1v1l1.4-0.2v1.2l-4.3,0.5l-0.2-1.2c0.5,0,1.1-0.1,1.7-0.2
			V82h-1.2v-1.1h1.2V80c-0.5,0-0.9,0-1.3,0c0-0.3-0.2-0.7-0.3-1c1.2-0.1,2.8-0.2,3.7-0.4L31.2,79.6z M33,71.2v14.4h-1.5v-7.7
			c-1.7,0.1-3.3,0.3-4.6,0.3L26.7,77l1-0.1v-5.7h-1v-1.3h7.1v1.3C33.8,71.2,33,71.2,33,71.2z M31.4,71.2h-2.2v1.1h2.2V71.2z
			 M31.4,73.4h-2.2v1.1h2.2V73.4z M29.2,76.8c0.7,0,1.5-0.1,2.2-0.1v-1.1h-2.2V76.8z M33,84.1c0.6-0.8,1.1-2.1,1.4-3.1l1.1,0.5
			c-0.3,1.1-0.8,2.4-1.4,3.3L33,84.1z M43,79.7h-9.4v-1.4H43V79.7z M37.2,73c0.1-0.3,0.1-0.7,0.2-1.1h-3.5v-1.3h3.7
			c0.1-0.5,0.1-1,0.2-1.4l1.4,0.1c-0.1,0.4-0.1,0.9-0.2,1.3h3.8v1.3h-4c-0.1,0.4-0.1,0.8-0.2,1.1h3.9v4.3h-8.3V73H37.2z M36.7,74.2
			h-1.2v1.9h1.2V74.2z M39.4,84.1c0.5,0,0.5-0.2,0.6-1.5c0.3,0.2,0.9,0.4,1.3,0.5c-0.1,1.9-0.5,2.3-1.7,2.3h-2
			c-1.5,0-1.9-0.4-1.9-1.7V81h1.4v2.6c0,0.4,0.1,0.5,0.6,0.5H39.4z M37.8,79.7c0.8,0.7,1.7,1.8,2,2.6L38.6,83
			c-0.4-0.8-1.2-1.9-1.9-2.7L37.8,79.7z M38.9,74.2h-1.2v1.9h1.2V74.2z M39.9,76.1h1.3v-1.9h-1.3V76.1z M41.3,80.6
			c0.9,1,1.7,2.4,2,3.4L42,84.6c-0.2-1-1-2.4-1.9-3.4L41.3,80.6z"
          />
          <path
            fill="#5D87C0"
            d="M59.6,83.9c0.3,0,0.4-0.3,0.5-2.1c0.3,0.3,1,0.6,1.4,0.7c-0.2,2.3-0.6,2.9-1.7,2.9h-1.4c-1.4,0-1.7-0.5-1.7-2
			v-4h-1.2c-0.3,2.8-1,5.1-3.7,6.3c-0.2-0.4-0.6-1-1-1.3c2.4-1,2.9-2.8,3.1-5h-1.4v-5.1c-0.3,0.3-0.5,0.6-0.8,0.8
			c-0.3-0.3-0.9-0.9-1.2-1.2c0.2-0.1,0.3-0.3,0.5-0.5h-6.2v-1.3h6.3v1.2c1.1-1.1,2.1-2.5,2.7-4l1.5,0.5c-0.6,1.5-1.6,2.9-2.6,4.1
			h6.7c-0.8-1.3-2-2.8-3.1-4l1.2-0.8c1.4,1.5,3.1,3.5,3.8,4.8L60,74.8c-0.1-0.3-0.3-0.6-0.6-1v5.5h-1.3v4c0,0.5,0.1,0.5,0.4,0.5
			L59.6,83.9L59.6,83.9z M50.8,84.6H47v0.8h-1.5v-6.1h5.2L50.8,84.6L50.8,84.6z M50.6,75.8h-5v-1.3h5V75.8z M45.6,76.9h5v1.3h-5
			V76.9z M47.8,72.1c-0.2-0.6-0.6-1.7-1-2.4l1.4-0.5c0.4,0.7,0.9,1.7,1.1,2.3L47.8,72.1z M47,80.6v2.6h2.3v-2.6H47z M54.2,77.9H58
			v-2.5h-3.8V77.9z"
          />
          <path
            fill="#5D87C0"
            d="M69.1,70.4c-0.5,1.5-1.1,3.2-1.7,4.6c1.2,1.4,1.5,2.7,1.5,3.8c0,1.1-0.2,1.8-0.7,2.2c-0.3,0.2-0.6,0.3-1,0.4
			c-0.3,0-0.8,0-1.2,0c0-0.4-0.1-1-0.4-1.4c0.4,0,0.7,0,0.9,0c0.2,0,0.4-0.1,0.5-0.2c0.3-0.2,0.3-0.6,0.3-1.2c0-0.9-0.3-2.1-1.5-3.5
			c0.5-1.2,0.9-2.7,1.2-3.9h-1.9v14.2h-1.4V69.8h3.9l0.2-0.1L69.1,70.4z M79.5,69.8v1.4h-10v-1.4H79.5z M79.2,84
			c0,0.7-0.1,1.1-0.6,1.3s-1.1,0.3-2,0.3c0-0.4-0.2-1-0.4-1.4c0.6,0,1.1,0,1.3,0c0.2,0,0.2-0.1,0.2-0.2v-6H71v7.6h-1.4v-8.9h9.6V84z
			 M78.6,75.9h-8.2v-3.7h8.2V75.9z M75.1,81.9v3.3h-1.4v-3.3h-2v-1.2h1.4c-0.3-0.6-0.8-1.5-1.2-2.1l1.1-0.4c0.5,0.6,1,1.5,1.3,2.1
			l-1,0.4h1.5c0.4-0.8,0.9-1.7,1.2-2.5l1.2,0.5c-0.4,0.7-0.8,1.4-1.2,2h1.2v1.2H75.1z M77.1,73.3h-5.3v1.4h5.3V73.3z"
          />
          <path
            fill="#5D87C0"
            d="M83.5,76.9c-0.3,0.8-0.6,1.6-1.1,2.3c-0.2-0.3-0.8-1-1.1-1.2c1.1-1.6,1.2-3.7,1.2-5.4v-3H89v4.1h-5
			c0,0.4-0.1,0.7-0.1,1.1h5.3v4.1h-5.7C83.5,78.9,83.5,76.9,83.5,76.9z M90.6,83.7h7.2v1.4H81.6v-1.4h7.2v-1.8h-5.4v-1.4h5.4v-1.3
			h1.7v1.3h5.6v1.4h-5.6v1.8H90.6z M84,71v1.5h3.5V71H84z M84.8,77.7h2.9v-1.6h-2.9V77.7z M97.9,73.4v1.4h-3.5v1.3h3.1v1.3h-3.1v1.9
			h-1.5v-1.9h-3.1v-1.3h3.1v-1.3h-3.4v-1.4h1.9c-0.1-0.5-0.3-1.1-0.5-1.5l1-0.3h-2v-1.3H93c-0.1-0.3-0.2-0.7-0.4-1L94,69
			c0.2,0.4,0.4,0.9,0.5,1.3h2.9v1.3H92c0.3,0.6,0.5,1.3,0.6,1.8h-0.1h1.8c0.2-0.6,0.5-1.3,0.6-1.8l1.5,0.2c-0.2,0.5-0.5,1.1-0.7,1.6
			H97.9z"
          />
          <path
            fill="#5D87C0"
            d="M115.8,71.9c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
			c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1s0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1H110c-0.5,1.2-1.1,2.2-1.6,3
			c-0.3-0.3-0.9-0.7-1.3-0.9v8.3h-4.9v1.4h-1.5V72h2c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6h2.9v3.4
			c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4H115.8z M102.1,73.4v3.4h3.3v-3.4H102.1z M105.5,82.3v-4h-3.3v4H105.5z
			 M111.5,80.9c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L111.5,80.9z"
          />
          <path
            fill="#5D87C0"
            d="M120.9,71.9v4.2c0,2.8-0.2,6.9-1.7,9.6c-0.3-0.3-0.9-0.8-1.3-1c1.3-2.5,1.4-6,1.4-8.6v-5.6h6.7
			c-0.1-0.4-0.3-0.7-0.4-1l1.7-0.4c0.2,0.4,0.4,1,0.6,1.4h6.5v1.4H120.9z M132.9,84.4c0.5,0,0.6-0.1,0.7-1c0.3,0.2,0.8,0.4,1.2,0.4
			c-0.1,1.2-0.5,1.6-1.7,1.6h-2.8c-1.7,0-2.1-0.3-2.1-1.5v-2.1h-1.3c-0.5,2-1.8,3.2-5.1,3.9c-0.1-0.4-0.5-1-0.8-1.2
			c2.8-0.5,3.9-1.3,4.3-2.6h-3v-4.5h2.5c0.1-0.3,0.3-0.5,0.4-0.7H124V74h-2.2v-1h2.2v-0.7h1.2V73h2.2v1h-2.2v2.7
			c0.1-0.1,0.1-0.2,0.1-0.3l1.6,0.3c-0.2,0.3-0.4,0.5-0.6,0.8h6.9V82h-1.9l0.6,0.2c-0.2,0.4-0.4,0.7-0.6,1l1-0.2
			c-0.1-0.2-0.2-0.4-0.3-0.6l0.7-0.2c0.3,0.5,0.6,1.1,0.8,1.5l-0.7,0.3c0-0.1-0.1-0.3-0.1-0.4c-1.8,0.3-2.2,0.5-2.4,0.6
			c-0.1-0.2-0.2-0.6-0.3-0.8c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.5-0.7,0.7-1.2h-1.4v2.1c0,0.4,0.1,0.5,0.8,0.5h2.4V84.4z M123.2,75
			c0,0.5-0.1,1.5-1.3,2c-0.1-0.2-0.5-0.5-0.8-0.7c1-0.4,1-1.1,1-1.4v-0.6h1V75H123.2z M123.7,79.1h3.3v-0.9h-3.3V79.1z M123.7,80.9
			h3.3V80h-3.3V80.9z M126.9,74.3v1c0,0.2,0,0.3,0.1,0.3s0.3,0,0.4-0.1c0,0.2,0,0.5,0.1,0.7c-0.1,0.1-0.4,0.1-0.6,0.1l0,0h-0.1
			c-0.7,0-0.9-0.4-0.9-1.1v-1L126.9,74.3L126.9,74.3z M129.1,75c0,0.5-0.1,1.4-0.9,1.9c-0.2-0.2-0.5-0.5-0.8-0.7
			c0.6-0.4,0.6-1,0.6-1.2v-0.6h1L129.1,75L129.1,75z M129.8,76.8v-2.9h-2.1v-1h2.1v-0.7h1.3v0.7h2.6v1h-2.6v2.9H129.8z M131.6,78.3
			h-3.2v0.9h3.2V78.3z M131.6,80h-3.2v0.9h3.2V80z M132.8,76.5c-0.8,0-1-0.3-1-1.1v-1.2h1v1.2c0,0.3,0,0.4,0.2,0.4h0.5
			c0.2,0,0.5,0,0.7-0.1l0.1,0.7c-0.1,0.1-0.5,0.1-0.7,0.1H132.8z"
          />
          <path
            fill="#5D87C0"
            d="M139.7,77.3c-0.7-0.6-2.2-1.4-3.3-1.9l0.9-1.3c1.1,0.5,2.6,1.2,3.3,1.8L139.7,77.3z M137,84.3
			c1-1.4,2.4-3.7,3.4-5.7l1.2,1.1c-0.9,1.9-2.1,4-3.2,5.7L137,84.3z M138.3,69.3c1.1,0.5,2.6,1.3,3.4,1.8l-1,1.4
			c-0.7-0.6-2.2-1.5-3.3-2L138.3,69.3z M151.1,85.6c-0.1-0.5-0.4-1.1-0.7-1.7c-6.4,0.8-7.2,0.9-7.7,1.2c-0.1-0.4-0.4-1.2-0.6-1.7
			c0.4-0.1,0.7-0.5,1.2-1.2c0.4-0.5,1.4-2.3,2.2-4.2h-3.7v-1.6h4.4v-2.9h-3.7V72h3.7v-2.9h1.7V72h3.8v1.6h-3.8v2.9h4.5v1.6h-5
			c-0.8,1.8-1.9,3.5-2.9,5l5-0.5c-0.4-0.7-0.9-1.4-1.4-2.1l1.4-0.6c1.2,1.6,2.6,3.7,3.1,5.1L151.1,85.6z"
          />
          <path
            fill="#5D87C0"
            d="M159.3,74.6c0.6,0.7,2.2,2.7,2.6,3.2l-0.9,1.6c-0.3-0.6-1-1.7-1.6-2.6v8.8h-1.6v-7.7
			c-0.6,1.7-1.4,3.3-2.2,4.4c-0.2-0.5-0.6-1.1-0.9-1.5c1.2-1.6,2.4-4.3,2.9-6.7h-2.4v-1.5h2.6v-3.4h1.6v3.4h2.2v1.5h-2.2v0.5H159.3z
			 M171.1,74.6h-2.3v8.8c0,1.1-0.3,1.6-1,1.9s-1.9,0.3-3.7,0.3c-0.1-0.5-0.4-1.3-0.6-1.8c1.4,0.1,2.6,0,3,0s0.5-0.1,0.5-0.5v-8.8h-5
			v-1.6h5.1v-3.8h1.7v3.8h2.3V74.6z M164.4,80.8c-0.4-1.1-1.2-2.9-1.9-4.2l1.4-0.6c0.8,1.3,1.6,3,2,4.2L164.4,80.8z"
          />
          <path
            fill="#5D87C0"
            d="M178.8,69.7c-0.5,1.3-1.1,2.6-1.8,3.8v12.1h-1.7v-9.5c-0.5,0.6-1,1.2-1.5,1.8c-0.2-0.4-0.6-1.4-0.9-1.7
			c1.7-1.7,3.3-4.3,4.3-6.9L178.8,69.7z M189.5,83.4V85H178v-1.6h5v-4.1h-4v-1.6h4v-3.6h-4.6v-1.6h10.9v1.6h-4.6v3.6h4.1v1.6h-4.1
			v4.1H189.5z M183.5,72.5c-0.2-0.8-0.8-2-1.4-2.9l1.5-0.5c0.6,0.9,1.2,2.1,1.5,2.9L183.5,72.5z"
          />
          <path
            fill="#5D87C0"
            d="M206.7,71.3c-1.6,1.7-4,3.6-6.2,4.9v7.4c0,1-0.3,1.5-1,1.8c-0.8,0.3-2,0.3-3.8,0.3c-0.1-0.5-0.4-1.2-0.7-1.7
			c1.4,0.1,2.8,0.1,3.2,0c0.4,0,0.5-0.1,0.5-0.4v-8.2c1.6-0.8,3.3-2.1,4.6-3.3h-11v-1.7H205l0.4-0.1L206.7,71.3z"
          />
          <path fill="#5D87C0" d="M43.1,97.9v1.8H26.7v-1.8H43.1z" />
          <path
            fill="#5D87C0"
            d="M51.8,100.5v5.8h-4.4v0.9h-1.5v-4.6c-0.3,0.5-0.6,0.9-1,1.3c-0.2-0.3-0.7-0.9-1.1-1.2c1-1,1.7-2.3,2.2-3.9
			h-1.1v-1.4h1.5c0.1-0.5,0.2-1,0.2-1.5H44v-1.4h2.8c0.1-0.5,0.1-1,0.1-1.5H45v-1.4h6.5v3h1V96h-1v2.9h-3.9
			c-0.2,0.6-0.3,1.1-0.5,1.6C47.1,100.5,51.8,100.5,51.8,100.5z M47.4,101.9v2.9h2.8v-2.9H47.4z M48.1,95.9c-0.1,0.5-0.2,1-0.3,1.5
			h2.1v-1.5H48.1z M48.4,93c-0.1,0.5-0.1,1-0.1,1.5h1.6V93H48.4z M60.5,103.1h-3.4v4.1h-1.6v-4.1h-3.2v-1.6h3.2v-2.3H53v-1.5h2.6
			v-2.1h-2.8v-1.5H54c-0.2-0.8-0.6-2-1.2-2.9l1.4-0.5c0.6,0.9,1.1,2.1,1.3,2.9L54.3,94h5.9v1.5h-3v2.1h2.7v1.5h-2.7v2.3h3.4v1.7
			H60.5z M59.9,91c-0.5,1.1-1,2.3-1.4,3.1L57,93.8c0.4-0.8,0.9-2.2,1.2-3.1L59.9,91z"
          />
          <path
            fill="#5D87C0"
            d="M67.8,94.5c-0.3,0.6-0.6,1.2-1,1.8h8.5v9c0,0.9-0.2,1.4-0.8,1.7c-0.6,0.3-1.6,0.3-3.1,0.3
			c-0.1-0.5-0.3-1.2-0.5-1.6c1.1,0.1,2.1,0.1,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-1.5h-7.3c-0.3,1.4-0.8,2.7-1.9,3.6
			c-0.2-0.4-0.9-1.1-1.2-1.3c1.5-1.4,1.7-3.3,1.7-5V99c-0.8,0.9-1.6,1.7-2.6,2.4c-0.3-0.4-0.8-1-1.1-1.3c2-1.3,3.5-3.3,4.6-5.5h-4.2
			V93h4.9c0.3-0.8,0.6-1.5,0.8-2.2l1.7,0.4c-0.2,0.6-0.4,1.2-0.6,1.9h9v1.6h-9.7V94.5z M73.8,102.3v-1.6h-7v0.3c0,0.4,0,0.8-0.1,1.3
			C66.7,102.3,73.8,102.3,73.8,102.3z M73.8,97.8h-7v1.5h7V97.8z"
          />
          <path
            fill="#5D87C0"
            d="M81.5,93.5v4.2c0,2.8-0.2,6.9-1.7,9.6c-0.3-0.3-0.9-0.8-1.3-1c1.3-2.5,1.4-6,1.4-8.6v-5.6h6.7
			c-0.1-0.4-0.3-0.7-0.4-1l1.7-0.4c0.2,0.4,0.4,1,0.6,1.4H95v1.4H81.5z M93.5,106c0.5,0,0.6-0.1,0.7-1c0.3,0.2,0.8,0.4,1.2,0.4
			c-0.1,1.2-0.5,1.6-1.7,1.6h-2.8c-1.7,0-2.1-0.3-2.1-1.5v-2.1h-1.3c-0.5,2-1.8,3.2-5.1,3.9c-0.1-0.4-0.5-1-0.8-1.2
			c2.8-0.5,3.9-1.3,4.3-2.6h-3V99h2.5c0.1-0.3,0.3-0.5,0.4-0.7h-1.2v-2.7h-2.2v-1h2.2v-0.7h1.2v0.7H88v1h-2.2v2.7
			c0.1-0.1,0.1-0.2,0.1-0.3l1.6,0.3c-0.2,0.3-0.4,0.5-0.6,0.8h6.9v4.5h-1.9l0.6,0.2c-0.2,0.4-0.4,0.7-0.6,1l1-0.2
			c-0.1-0.2-0.2-0.4-0.3-0.6l0.7-0.2c0.3,0.5,0.6,1.1,0.8,1.5l-0.7,0.3c0-0.1-0.1-0.3-0.1-0.4c-1.8,0.3-2.2,0.5-2.4,0.6
			c-0.1-0.2-0.2-0.6-0.3-0.8c0.1,0,0.3-0.1,0.4-0.2s0.5-0.7,0.7-1.2h-1.4v2.1c0,0.4,0.1,0.5,0.8,0.5h2.4V106z M83.8,96.6
			c0,0.5-0.1,1.5-1.3,2c-0.1-0.2-0.5-0.5-0.8-0.7c1-0.4,1-1.1,1-1.4v-0.6h1v0.7H83.8z M84.3,100.7h3.3v-0.9h-3.3V100.7z M84.3,102.5
			h3.3v-0.9h-3.3V102.5z M87.5,95.9v1c0,0.2,0,0.3,0.1,0.3s0.3,0,0.4-0.1c0,0.2,0,0.5,0.1,0.7C87.9,98,87.7,98,87.5,98l0,0h-0.1
			c-0.7,0-0.9-0.4-0.9-1.1v-1H87.5z M89.7,96.6c0,0.5-0.1,1.4-0.9,1.9c-0.2-0.2-0.5-0.5-0.8-0.7c0.6-0.4,0.6-1,0.6-1.2V96h1v0.6
			H89.7z M90.4,98.4v-2.9h-2.1v-1h2.1v-0.7h1.3v0.7h2.6v1h-2.6v2.9H90.4z M92.3,99.9H89v0.9h3.2v-0.9H92.3z M92.3,101.6H89v0.9h3.2
			v-0.9H92.3z M93.4,98.1c-0.8,0-1-0.3-1-1.1v-1.2h1V97c0,0.3,0,0.4,0.2,0.4h0.5c0.2,0,0.5,0,0.7-0.1l0.1,0.7
			c-0.1,0.1-0.5,0.1-0.7,0.1H93.4z"
          />
          <path
            fill="#5D87C0"
            d="M111.6,94.5c0,0,0,0.6,0,0.8c-0.4,7.3-0.7,10-1.5,10.9c-0.5,0.6-1,0.8-1.7,0.8c-0.6,0.1-1.8,0.1-2.9,0
			c0-0.5-0.3-1.2-0.6-1.7c1.2,0.1,2.3,0.1,2.7,0.1c0.4,0,0.6-0.1,0.8-0.3c0.6-0.6,1-3,1.3-8.9h-5.6c-0.3,3.7-1.5,8.1-6.6,11.1
			c-0.3-0.4-0.9-1-1.3-1.3c4.7-2.7,5.9-6.5,6.1-9.7h-5.6v-1.7h5.7v-0.5v-3.3h1.8v3.3v0.5h7.4V94.5z"
          />
          <path
            fill="#5D87C0"
            d="M129.4,93.5c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
			c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1s0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1h-4.2c-0.5,1.2-1.1,2.2-1.6,3
			c-0.3-0.3-0.9-0.7-1.3-0.9v8.3h-4.9v1.4h-1.5V93.6h2c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6h2.9V97
			c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4H129.4z M115.8,95v3.4h3.3V95H115.8z M119.1,103.9v-4h-3.3v4H119.1z
			 M125.1,102.5c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L125.1,102.5z"
          />
          <path
            fill="#5D87C0"
            d="M144.9,105.6c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3H142c-2,0-2.5-0.5-2.5-2.1
			v-3.7h-0.2c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6h-4.7V97c-0.3,0.2-0.6,0.5-0.9,0.7
			c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.2-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1h4.1l0.3-0.1l1.2,0.8c-0.5,0.8-1.1,1.8-1.8,2.6
			h5.2v6h-4.8v3.7c0,0.6,0.2,0.7,1,0.7h2.6V105.6z M137.9,99.8c0.2-1,0.3-2,0.4-3h-4v3H137.9z M136,93.4c-0.5,0.6-1,1.3-1.6,1.9h4.2
			c0.5-0.6,1-1.3,1.4-1.9H136z M144.1,96.8H140c-0.1,1.1-0.2,2.1-0.4,3h4.5V96.8z M143,101.4c0.9,0.7,2,1.7,2.5,2.4l-1.2,1
			c-0.5-0.7-1.6-1.8-2.5-2.5L143,101.4z"
          />
          <path
            fill="#5D87C0"
            d="M164.5,100.2h-7.1v4.9c0,1-0.3,1.5-1,1.8c-0.8,0.3-1.9,0.3-3.6,0.3c-0.1-0.5-0.4-1.3-0.7-1.7
			c1.4,0.1,2.7,0.1,3.1,0c0.4,0,0.5-0.1,0.5-0.4v-4.9h-7.3v-1.7h7.3V96c1.3-0.6,2.9-1.6,4.1-2.5h-9.5v-1.6h11.4l0.4-0.1l1.3,1
			c-1.5,1.5-3.7,3.1-5.8,4.2v1.7h7.1v1.5H164.5z"
          />
          <path
            fill="#5D87C0"
            d="M166.5,107.3c1.4-0.5,2.2-1.4,2.3-2.4c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.5-1.5-1.4s0.7-1.4,1.5-1.4
			c1.1,0,1.7,0.9,1.7,2.2c0,2-1.3,3.5-3.3,4.2L166.5,107.3z"
          />
          <path
            fill="#5D87C0"
            d="M189.6,100.1c-0.5,1.7-1.3,3-2.4,4.1c1,0.7,2.1,1.2,3.3,1.5c-0.4,0.3-0.8,0.9-1,1.3c-1.3-0.4-2.5-1-3.5-1.7
			c-1,0.8-2.2,1.4-3.4,1.8c-0.2-0.4-0.5-1-0.9-1.3v1.4h-1.6v-1.7c-2.2,0.2-4.3,0.5-5.9,0.7l-0.1-1.5c0.5,0,1-0.1,1.6-0.1v-5.8h-1.5
			v-1.4H190v1.4h-8.3v7c1.1-0.3,2.2-0.9,3.1-1.6c-0.8-0.9-1.4-1.9-1.9-3l0.4-0.1h-1v-1.3h5.9l0.3-0.1L189.6,100.1z M178,96.8h-1.6
			v-5.5H188v5.5h-1.7v-4.3H178V96.8z M177.2,98.8v1h3v-1H177.2z M177.2,102.1h3v-1h-3V102.1z M177.2,104.5c0.9-0.1,1.9-0.2,3-0.3
			v-0.9h-3V104.5z M185.5,93.3v1h-6.8v-1H185.5z M178.7,95.2h6.9v1h-6.9V95.2z M184.4,101.1c0.4,0.8,0.9,1.5,1.5,2.2
			c0.6-0.6,1.2-1.4,1.6-2.2H184.4z"
          />
          <path
            fill="#5D87C0"
            d="M200.5,91.1c-0.1,0.1-0.2,0.2-0.3,0.3c1.7,1.5,4.7,2.9,7.5,3.5c-0.3,0.3-0.8,0.9-1.1,1.3
			c-0.4-0.1-0.9-0.3-1.3-0.4v4.7h-12.2V96c-0.5,0.2-0.9,0.3-1.3,0.4c-0.1-0.3-0.6-1-0.9-1.3c3.3-0.8,6.4-2.4,8.1-4.5L200.5,91.1z
			 M205.3,95.8c-1-0.3-2-0.8-2.9-1.3V95h-6.2v-0.4c-0.8,0.5-1.7,0.8-2.6,1.2C193.6,95.8,205.3,95.8,205.3,95.8z M194.2,101.2h10.3
			v5.9h-1.7v-0.5h-6.9v0.6h-1.7L194.2,101.2L194.2,101.2z M196.6,97c0.4,0.6,0.8,1.4,0.9,2l-1.2,0.4h2.1v-2.5h-3.9v2.5h1.7
			c-0.1-0.6-0.5-1.4-0.8-2L196.6,97z M195.8,102.4v1h6.9v-1H195.8z M202.7,105.5v-1h-6.9v1H202.7z M201.3,93.9c-0.7-0.5-1.4-1-2-1.5
			c-0.6,0.5-1.3,1.1-2,1.5H201.3z M203.8,96.9h-4v2.5h2l-1.1-0.3c0.3-0.6,0.7-1.5,0.9-2.1l1.4,0.4c-0.4,0.8-0.8,1.5-1.1,2.1h1.9
			L203.8,96.9L203.8,96.9z"
          />
          <path
            fill="#5D87C0"
            d="M30,120.6c-0.7-0.5-2.2-1.4-3.3-1.9l0.9-1.2c1,0.5,2.6,1.3,3.3,1.8L30,120.6z M27,127.5
			c1-1.4,2.4-3.7,3.4-5.7l1.2,1.1c-0.9,1.9-2.1,4-3.2,5.7L27,127.5z M31.1,115.7c-0.8-0.6-2.3-1.4-3.4-2l0.9-1.2
			c1.1,0.5,2.6,1.3,3.4,1.8L31.1,115.7z M41.4,120.5c-0.1-0.3-0.3-0.7-0.6-1.1c-7.4,0.5-8.3,0.6-8.9,0.8c-0.1-0.3-0.4-1.1-0.6-1.6
			c0.4-0.1,0.8-0.5,1.2-1.1c0.5-0.6,2-3,3-5.3l1.7,0.5c-1,2-2.2,3.9-3.4,5.5l5.9-0.4c-0.6-0.9-1.4-1.9-2.1-2.7l1.4-0.7
			c1.4,1.6,3,3.7,3.7,5.1L41.4,120.5z M32.5,121.5h9.1v7.2h-1.7V128h-5.8v0.8h-1.6V121.5z M34.1,123.1v3.4h5.8v-3.4H34.1z"
          />
          <path
            fill="#5D87C0"
            d="M59.9,118.8c-0.4,0.5-0.9,0.8-1.4,1.2c0.6,0.4,1.3,0.8,2,1.1c-0.3,0.3-0.8,0.8-1,1.2
			c-0.5-0.2-0.9-0.5-1.3-0.7v3.3H55v2.5c0,0.7-0.1,1.1-0.7,1.3c-0.6,0.2-1.3,0.2-2.5,0.2c-0.1-0.4-0.3-1-0.5-1.4c0.8,0,1.5,0,1.8,0
			c0.2,0,0.3-0.1,0.3-0.3v-2.5h-3.2v-3.3c-0.4,0.3-0.8,0.5-1.3,0.8c-0.2-0.3-0.6-0.8-0.9-1c-0.1,2.5-0.7,5.6-2.5,7.6
			c-0.3-0.3-0.9-0.9-1.2-1.1c1.3-1.5,1.8-3.3,2.1-5.1c-0.7,0.4-1.4,0.8-2.1,1.2l-0.5-1.5c0.7-0.3,1.7-0.8,2.7-1.3c0-0.5,0-0.9,0-1.4
			v-5.7h6.1c-0.1-0.4-0.3-0.9-0.4-1.3l1.7-0.3c0.2,0.5,0.4,1.1,0.6,1.6h6v1.4H48v4.3c0,0.5,0,1,0,1.5c0.7-0.4,1.4-0.8,2-1.2
			c-0.4-0.3-0.8-0.7-1.2-1l0.9-0.8c0.4,0.3,0.9,0.6,1.3,1c0.4-0.4,0.7-0.7,1-1.1h-3.1v-1.3h3.9c0.3-0.5,0.4-0.9,0.6-1.4l1.6,0.2
			c-0.1,0.4-0.3,0.8-0.5,1.2h5.9v1.3h-3.6c0.3,0.5,0.7,0.9,1.2,1.3c0.5-0.4,1-0.8,1.2-1.2L59.9,118.8z M45,119.5
			c-0.2-0.9-0.7-2.4-1.1-3.5l1.2-0.5c0.4,1.1,0.9,2.6,1.1,3.4L45,119.5z M51.8,125.5c-0.8,1-1.9,2.2-2.7,2.9c-0.3-0.3-0.9-0.7-1.3-1
			c0.9-0.7,1.9-1.6,2.5-2.5L51.8,125.5z M56.8,120.9h-5.3v0.9h5.3V120.9z M56.8,122.8h-5.3v0.9h5.3V122.8z M53.5,118
			c-0.4,0.6-0.9,1.3-1.4,1.9h4.3c-0.5-0.6-1-1.2-1.4-1.9H53.5z M57.4,125c0.9,0.8,2.1,2,2.7,2.7l-1.3,0.8c-0.6-0.7-1.7-1.9-2.6-2.8
			L57.4,125z"
          />
          <path
            fill="#5D87C0"
            d="M66.1,120.9c-0.3,1.6-0.9,3.2-1.6,4.5c0.3,0.2,0.7,0.5,1.2,0.8c1.2,0.7,2.9,0.8,5,0.8s5.2-0.2,7.3-0.4
			c-0.2,0.5-0.5,1.3-0.5,1.8c-1.4,0.1-4.7,0.2-6.8,0.2c-2.3,0-3.9-0.2-5.2-0.9c-0.7-0.4-1.4-1-1.8-1c-0.4,0-1,1.1-1.5,2.2l-1.1-1.6
			c0.5-0.7,1.1-1.3,1.6-1.6l0,0c0.8-0.9,1.4-2.3,1.7-3.6h-2.5c0.5-1.1,1.1-2.5,1.6-3.9h-2.1v-1.5h4.2c-0.5,1.3-1,2.8-1.6,4h0.9
			l0.2-0.1L66.1,120.9z M63.5,115.8c-0.3-0.8-0.9-2.1-1.4-3l1.4-0.5c0.5,0.9,1.1,2.1,1.4,2.9L63.5,115.8z M77.4,115.7H66.1v-1.3h5
			c-0.3-0.5-0.6-1.2-1-1.7l1.6-0.5c0.5,0.6,1,1.4,1.2,1.9l-0.8,0.3h5.3C77.4,114.4,77.4,115.7,77.4,115.7z M67.3,121.3H76v4.4h-8.8
			v-4.4H67.3z M75.9,117.9h-8.4v-1.2h8.4V117.9z M67.5,119h8.4v1.2h-8.4V119z M68.9,124.5h5.5v-1.9h-5.5V124.5z"
          />
          <path
            fill="#5D87C0"
            d="M84.4,123.5c-0.3-0.5-0.9-1.3-1.4-2.1v7.4h-1.6v-7.3c-0.7,1.6-1.5,3.2-2.3,4.2c-0.2-0.5-0.6-1.2-0.8-1.5
			c1.1-1.2,2.2-3.4,2.9-5.3h-2.6v-1.6h2.8v-2.4c-0.8,0.2-1.7,0.3-2.4,0.4c-0.1-0.4-0.3-0.9-0.5-1.3c2-0.3,4.3-0.8,5.6-1.4l1.2,1.3
			c-0.6,0.3-1.4,0.5-2.2,0.7v2.8h2.1v1.6H83v0.8c0.5,0.5,2.1,2,2.4,2.4L84.4,123.5z M95,127.1v1.3H84.3v-1.3H89V126h-3.7v-1.3H89
			v-1.1h-3.6v-5.8H89v-1h-4.2v-1.3H89v-1c-1.2,0.1-2.5,0.1-3.6,0.1c0-0.3-0.2-0.9-0.4-1.2c3-0.1,6.6-0.4,8.6-0.8l1,1.2
			c-1.1,0.3-2.5,0.4-4,0.6v1.1h4v1.3h-4v1h3.7v5.8h-3.7v1.1h3.7v1.3h-3.7v1.2L95,127.1L95,127.1z M86.9,120.1H89v-1.2h-2.1V120.1z
			 M89,122.4v-1.2h-2.1v1.2H89z M90.7,118.9v1.2h2.2v-1.2H90.7z M92.8,121.2h-2.2v1.2h2.2V121.2z"
          />
          <path
            fill="#5D87C0"
            d="M95.6,120.4c0.5-1.2,0.8-3.1,0.8-4.6l1.3,0.2c0,1.5-0.3,3.6-0.8,4.9L95.6,120.4z M100.9,119
			c-0.2-0.8-0.7-2-1.1-3v12.8h-1.6v-16.5h1.6v3.3l1.1-0.5c0.5,1,1.1,2.4,1.3,3.2L100.9,119z M111.2,113.5c-0.7,1.9-1.7,3.4-3.1,4.6
			c1.2,0.7,2.7,1.3,4.3,1.6c-0.4,0.3-0.8,1-1.1,1.4c-1.8-0.4-3.3-1.1-4.6-2c-1.5,1-3.3,1.7-5.1,2.1c-0.2-0.4-0.5-1.1-0.8-1.4
			c1.7-0.3,3.3-0.9,4.7-1.7c-1-1-1.8-2.1-2.5-3.4l0.4-0.1H102v-1.5h7.8l0.3-0.1L111.2,113.5z M107.6,126.8h4.6v1.5h-11.1v-1.5h4.8
			v-2.6h-4v-1.5h4v-1.8h1.7v1.8h3.9v1.5h-3.9V126.8z M104.6,114.6c0.5,1,1.3,1.9,2.2,2.6c0.9-0.7,1.7-1.6,2.2-2.6H104.6z"
          />
          <path
            fill="#5D87C0"
            d="M129.5,114.3v1.5h-12v3.8c0,2.8-0.4,6.7-2.8,9.2c-0.2-0.3-0.9-0.9-1.2-1.1c1.3-1.4,1.9-3,2.2-4.7
			c-0.7,0.4-1.5,0.9-2.2,1.3l-0.5-1.5c0.8-0.3,1.8-0.8,2.9-1.4c0-0.6,0-1.1,0-1.6v-5.3h6.2c-0.1-0.6-0.3-1.2-0.5-1.7l1.8-0.3
			c0.2,0.6,0.5,1.4,0.7,2.1h5.4V114.3z M114.4,119.7c-0.2-0.9-0.7-2.3-1.3-3.4l1.2-0.6c0.6,1,1.2,2.4,1.4,3.3L114.4,119.7z
			 M118.1,117.1h11.2v1.4h-5.1v1.6h4.6v6.9c0,0.8-0.1,1.2-0.7,1.5c-0.6,0.3-1.4,0.3-2.6,0.3c-0.1-0.5-0.3-1.1-0.5-1.5
			c0.8,0,1.7,0,1.9,0c0.3,0,0.3-0.1,0.3-0.3v-5.5h-3.1c0,0.3-0.1,0.6-0.1,0.9c1,0.9,2.3,2.1,2.9,2.9l-1.1,0.9
			c-0.5-0.6-1.4-1.6-2.3-2.5c-0.5,1-1.3,2-2.6,2.7c-0.2-0.3-0.7-0.8-1-1.1c2-1,2.6-2.5,2.7-3.8h-2.8v7.2h-1.5V120h4.3v-1.6H118
			L118.1,117.1L118.1,117.1z"
          />
          <path
            fill="#5D87C0"
            d="M134.7,122.9c1.6,0,2.8,1.3,2.8,2.8s-1.2,2.8-2.8,2.8c-1.5,0-2.8-1.3-2.8-2.8
			C131.9,124.2,133.1,122.9,134.7,122.9z M134.7,127.4c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7
			C132.9,126.7,133.7,127.4,134.7,127.4z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogCText;



// WEBPACK FOOTER //
// ./src/fearCity/components/DialogCText.tsx